import { HttpClient } from "@angular/common/http";
import { AppConfig } from "../../global/config/app.config";
import { Inject, Injectable } from "@angular/core";
import { APP_CONFIG } from "../../global/config/config.token";
import { Observable } from "rxjs";
import { DonorFlagFormModel } from "../models/DonorModel";
import { CheckbookLU, FundType } from "../models/CommonModels";

@Injectable({
    providedIn: 'root'
})
export class LookupService {
    constructor(private httpClient: HttpClient,
                @Inject(APP_CONFIG) private config: AppConfig)
    { }

    getFundTypes = (): Observable<Array<FundType>> => {
        return this.httpClient.get<FundType[]>(`${this.config.apiUrl}Lookups/FundTypes`, { withCredentials: true });
    }

    getCampaignCheckbooks = (campaignId: number): Observable<Array<CheckbookLU>> => {
        return this.httpClient.get<CheckbookLU[]>(`${this.config.apiUrl}Lookups/campaign-checkbooks?campaignId=${campaignId}`, { withCredentials: true });
    }
}